import { create } from 'zustand';

/**
 * Demo-mode disclosure store.
 *
 * Flipped by the demo interceptor the first time a synthesized payload is
 * served (API unreachable in dev). Read by the globe scene to show the
 * "Demo data" chip — we never present synthesized data as real.
 */
interface DemoStore {
  active: boolean;
}

export const useDemoStore = create<DemoStore>(() => ({ active: false }));

export function activateDemoMode(): void {
  if (!useDemoStore.getState().active) {
    useDemoStore.setState({ active: true });
  }
}
